import React, { useEffect } from 'react';
import { motion, useMotionValue, useTransform, animate } from 'framer-motion';

export default function StatCard({ icon: Icon, label, value, subText, color = '#3B82F6', delay = 0, accent = false }) {
  const mv = useMotionValue(0);
  const isNumeric = typeof value === 'number';
  const displayText = useTransform(mv, (v) => Math.round(v).toLocaleString('es-MX'));

  useEffect(() => {
    if (!isNumeric) return;
    const controls = animate(mv, value, {
      duration: 1.2,
      ease: [0.16, 1, 0.3, 1],
      delay,
    });
    return controls.stop;
  }, [value, isNumeric, delay, mv]);

  const colorAlpha14 = color + '24';
  const colorAlpha30 = color + '4D';

  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1], delay }}
      whileHover={{ y: -3, boxShadow: '0 12px 32px rgba(0,0,0,0.5)' }}
      style={{
        background: 'linear-gradient(160deg, rgb(var(--panel)) 0%, rgb(var(--panel)) 55%, rgb(var(--panel)) 100%)',
        border: '1px solid rgb(var(--fg) / 0.07)',
        boxShadow: '0 4px 24px rgba(0,0,0,0.35)',
        borderRadius: '12px',
        padding: '20px',
        display: 'flex',
        alignItems: 'flex-start',
        gap: '16px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {accent && (
        <div style={{
          position: 'absolute', top: 0, left: 0, right: 0, height: '2px',
          background: 'linear-gradient(90deg, #DC1F26 0%, #3B82F6 60%, #00C2FF 100%)',
        }} />
      )}
      {/* radial color wash */}
      <div style={{
        position: 'absolute', top: 0, right: 0,
        width: '120px', height: '120px',
        background: `radial-gradient(circle at 85% 15%, ${colorAlpha14}, transparent 70%)`,
        pointerEvents: 'none',
      }} />
      {Icon && (
        <div style={{
          width: '44px', height: '44px',
          borderRadius: '10px',
          background: colorAlpha14,
          border: `1px solid ${colorAlpha30}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <Icon size={20} color={color} />
        </div>
      )}
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: '11px', color: 'rgb(var(--fg-faint))', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '6px' }}>
          {label}
        </div>
        <div style={{ fontSize: '26px', fontWeight: 700, color: 'rgb(var(--fg))', lineHeight: 1 }}>
          {isNumeric ? <motion.span>{displayText}</motion.span> : value}
        </div>
        {subText && (
          <div style={{ fontSize: '12px', color: 'rgb(var(--fg-faint))', marginTop: '6px' }}>{subText}</div>
        )}
      </div>
    </motion.div>
  );
}
